import l10n from './strings';

/**
 * Server subcodes meaning Google Drive itself refused the upload on quota grounds.
 * Neither clears by retrying, so the UI explains what can actually unblock the user.
 */
export const GD_QUOTA_SUBCODES = [
  'GoogleDriveStorageQuotaExceededError',
  'GoogleDriveDailyUploadLimitError',
];

/** Dialog heading per subcode, keyed so a new subcode can never silently reuse the wrong one */
export const GD_QUOTA_DIALOG_TITLE = {
  GoogleDriveStorageQuotaExceededError: l10n.DIALOGS.GD_STORAGE_QUOTA_EXCEEDED.TITLE,
  GoogleDriveDailyUploadLimitError: l10n.DIALOGS.GD_DAILY_UPLOAD_LIMIT.TITLE,
};

/**
 * Short standalone sentence for the single-line Import row, where the server's own
 * message would read as truncated because its remedies only reach the dialog.
 */
export const GD_QUOTA_INLINE_ERROR = {
  GoogleDriveStorageQuotaExceededError: l10n.IMPORT.ITEM.gdStorageQuotaExceeded,
  GoogleDriveDailyUploadLimitError: l10n.IMPORT.ITEM.gdDailyUploadLimit,
};

/**
 * @param {string} [subcode] - server `subcode`, carried through upload state as `error.reason`
 * @returns {boolean} true when Google Drive rejected the upload on quota grounds
 */
export const isGDQuotaSubcode = (subcode) => GD_QUOTA_SUBCODES.includes(subcode);

/**
 * Flatten the server's quota message and its remedies into one tooltip string, so the
 * advice stays reachable on the Import row after the dialog has been dismissed.
 * @param {string} message - the server's `msg`
 * @param {string[]} [reasons] - the remedies the server sent
 * @returns {string}
 */
export function buildQuotaTooltip(message, reasons) {
  if (!reasons?.length) return message;
  return `${message} ${reasons.map((reason) => `\u2022 ${reason}`).join(' ')}`;
}
